import { render } from "./HomeView.vue?vue&type=template&id=651ff49d&scoped=true"
import script from "@/wwwroot/js/home.js?vue&type=script&lang=js"
export * from "@/wwwroot/js/home.js?vue&type=script&lang=js"

import "@/wwwroot/css/home.css?vue&type=style&index=0&id=651ff49d&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651ff49d"]])

export default __exports__